// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-link {\n  font-size: 1.2rem;\n  text-decoration: none;\n}\n.title-link:hover, .title-link:focus {\n  text-decoration: underline;\n}\n.title-link.v-btn.theme--dark {\n  text-transform: none;\n  color: #ff7500;\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: 0;\n}\n.provider__img {\n  height: 28px;\n  width: 28px;\n  margin-right: 12px;\n}", ""]);
// Exports
module.exports = exports;
